import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { APP_NAME } from "@shared/util/brand";
import customAxios, { setAuthToken } from "@shared/util/customAxios";
import { readStoredUser } from "@shared/util/authSession";

export default function StripeSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [ready, setReady] = useState(false);
  const [syncError, setSyncError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function refreshSession() {
      const stored = readStoredUser();
      const sessionId = searchParams.get("session_id");
      if (stored?.token) {
        setAuthToken(stored.token);
        try {
          if (sessionId) {
            try {
              await customAxios.post(
                `${import.meta.env.VITE_API_URL}/stripe/condense/sync-checkout-session`,
                { session_id: sessionId }
              );
            } catch (err) {
              console.error("Could not sync Condense checkout session:", err);
              if (!cancelled) {
                setSyncError(
                  err.response?.data?.error ||
                    "Payment succeeded but account sync is still pending. Try Billing → refresh, or contact support."
                );
              }
            }
          }

          const res = await customAxios.post(
            `${import.meta.env.VITE_API_URL}/auth/check`,
            {}
          );
          if (res?.data) {
            const updated = { ...stored, ...res.data };
            localStorage.setItem("futureOfTV_User", JSON.stringify(updated));
          }
        } catch (err) {
          console.error("Could not refresh membership after checkout:", err);
        }
      }
      if (!cancelled) setReady(true);
    }

    refreshSession();
    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  useEffect(() => {
    if (!ready) return undefined;
    const timer = setTimeout(() => {
      window.location.href = "/asset/webinars";
    }, 1500);
    return () => clearTimeout(timer);
  }, [ready]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="relative bg-white dark:bg-gray-800 p-10 rounded-2xl text-center max-w-md w-full shadow-xl">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-green-200 flex items-center justify-center text-3xl">
          ✅
        </div>
        <h3 className="text-2xl font-semibold mb-3 dark:text-gray-100">
          Payment Successful!
        </h3>
        <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
          Thank you for your purchase. Your membership has been updated and you
          can now enjoy all features.
        </p>
        {syncError && (
          <p className="text-sm text-amber-700 dark:text-amber-300 mb-4">{syncError}</p>
        )}
        <button
          type="button"
          onClick={() => {
            window.location.href = "/asset/webinars";
          }}
          className="w-full px-6 py-4 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg"
        >
          Go to the {APP_NAME} home page!
        </button>
      </div>
    </div>
  );
}
